var api = require("!../../../../../../../AppData/Roaming/nvm/v12.22.12/node_modules/expo-cli/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../AppData/Roaming/nvm/v12.22.12/node_modules/expo-cli/node_modules/css-loader/dist/cjs.js!./confirm-alert.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};